// extracted by mini-css-extract-plugin
export default {"buttonWrap":"leave-checkout-modal_buttonWrap__ca843","header":"leave-checkout-modal_header__f1ef7","modal":"leave-checkout-modal_modal__0e204"};